function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.725 10.516h-3.324A2.39 2.39 0 0016.158 9a2.39 2.39 0 00-2.243 1.516h-3.324c-.875 0-1.591.682-1.591 1.516v10.61c0 .834.716 1.516 1.59 1.516h11.135c.875 0 1.59-.682 1.59-1.516v-10.61c0-.834-.715-1.516-1.59-1.516zm-5.146.168c.463 0 .842.38.842.842a.845.845 0 01-.842.842.845.845 0 01-.842-.842c0-.463.379-.842.842-.842zm1.684 10.948h-5.895v-1.685h5.895v1.685zm1.684-3.369h-7.579V16.58h7.58v1.684zm0-2.526h-7.579v-1.684h7.58v1.684z",
  fill: "#888",
  fillRule: "nonzero"
})));